export const fontFilesManifest = {
  fonts: [
    {
      fontFamily: 'Abel',
      displayName: 'Abel',
      Regular: {
        name: 'Abel-Regular',
        filename: 'Abel-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'AbhayaLibre',
      displayName: 'Abhaya Libre',
      Bold: {
        name: 'AbhayaLibre-Bold',
        filename: 'AbhayaLibre-Bold.woff2',
        variable: false
      },
      Regular: {
        name: 'AbhayaLibre-Regular',
        filename: 'AbhayaLibre-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'AbrilFatface',
      displayName: 'Abril Fatface',
      Regular: {
        name: 'AbrilFatface-Regular',
        filename: 'AbrilFatface-Regular.woff2',
        variable: false,
        pixelRange: 18
      }
    },
    {
      fontFamily: 'Acme',
      displayName: 'Acme',
      Regular: {
        name: 'Acme-Regular',
        filename: 'Acme-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'Alef',
      displayName: 'Alef',
      Bold: {
        name: 'Alef-Bold',
        filename: 'Alef-Bold.woff2',
        variable: false
      },
      Regular: {
        name: 'Alef-Regular',
        filename: 'Alef-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'Alegreya',
      displayName: 'Alegreya',
      Italic: {
        name: 'Alegreya-Italic',
        filename: 'Alegreya-Italic[wght].woff2',
        variable: true,
        variableWeight: 400
      },
      BoldItalic: {
        name: 'Alegreya-BoldItalic',
        filename: 'Alegreya-Italic[wght].woff2',
        variable: true,
        variableWeight: 700
      },
      Regular: {
        name: 'Alegreya-Regular',
        filename: 'Alegreya[wght].woff2',
        variable: true,
        variableWeight: 400
      },
      Bold: {
        name: 'Alegreya-Bold',
        filename: 'Alegreya[wght].woff2',
        variable: true,
        variableWeight: 700
      }
    },
    {
      fontFamily: 'AlegreyaSans',
      displayName: 'Alegreya Sans',
      Bold: {
        name: 'AlegreyaSans-Bold',
        filename: 'AlegreyaSans-Bold.woff2',
        variable: false
      },
      BoldItalic: {
        name: 'AlegreyaSans-BoldItalic',
        filename: 'AlegreyaSans-BoldItalic.woff2',
        variable: false
      },
      Italic: {
        name: 'AlegreyaSans-Italic',
        filename: 'AlegreyaSans-Italic.woff2',
        variable: false
      },
      Regular: {
        name: 'AlegreyaSans-Regular',
        filename: 'AlegreyaSans-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'AmaticSC',
      displayName: 'Amatic SC',
      Bold: {
        name: 'AmaticSC-Bold',
        filename: 'AmaticSC-Bold.woff2',
        variable: false,
        pixelRange: 15
      },
      Regular: {
        name: 'AmaticSC-Regular',
        filename: 'AmaticSC-Regular.woff2',
        variable: false,
        pixelRange: 20
      }
    },
    {
      fontFamily: 'Amiri',
      displayName: 'Amiri',
      Bold: {
        name: 'Amiri-Bold',
        filename: 'Amiri-Bold.woff2',
        variable: false
      },
      BoldItalic: {
        name: 'Amiri-BoldItalic',
        filename: 'Amiri-BoldItalic.woff2',
        variable: false
      },
      Italic: {
        name: 'Amiri-Italic',
        filename: 'Amiri-Italic.woff2',
        variable: false
      },
      Regular: {
        name: 'Amiri-Regular',
        filename: 'Amiri-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'Angkor',
      displayName: 'Angkor',
      Regular: {
        name: 'Angkor-Regular',
        filename: 'Angkor-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'Anton',
      displayName: 'Anton',
      Regular: {
        name: 'Anton-Regular',
        filename: 'Anton-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'ArchivoBlack',
      displayName: 'Archivo Black',
      Regular: {
        name: 'ArchivoBlack-Regular',
        filename: 'ArchivoBlack-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'Arimo',
      displayName: 'Arimo',
      Italic: {
        name: 'Arimo-Italic',
        filename: 'Arimo-Italic[wght].woff2',
        variable: true,
        variableWeight: 400
      },
      BoldItalic: {
        name: 'Arimo-BoldItalic',
        filename: 'Arimo-Italic[wght].woff2',
        variable: true,
        variableWeight: 700
      },
      Regular: {
        name: 'Arimo-Regular',
        filename: 'Arimo[wght].woff2',
        variable: true,
        variableWeight: 400
      },
      Bold: {
        name: 'Arimo-Bold',
        filename: 'Arimo[wght].woff2',
        variable: true,
        variableWeight: 700
      }
    },
    {
      fontFamily: 'Arvo',
      displayName: 'Arvo',
      Bold: {
        name: 'Arvo-Bold',
        filename: 'Arvo-Bold.woff2',
        variable: false
      },
      BoldItalic: {
        name: 'Arvo-BoldItalic',
        filename: 'Arvo-BoldItalic.woff2',
        variable: false
      },
      Italic: {
        name: 'Arvo-Italic',
        filename: 'Arvo-Italic.woff2',
        variable: false
      },
      Regular: {
        name: 'Arvo-Regular',
        filename: 'Arvo-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'Atma',
      displayName: 'Atma',
      Bold: {
        name: 'Atma-Bold',
        filename: 'Atma-Bold.woff2',
        variable: false
      },
      Regular: {
        name: 'Atma-Regular',
        filename: 'Atma-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'Baloo',
      displayName: 'Baloo',
      Regular: {
        name: 'Baloo-Regular',
        filename: 'Baloo-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'Baloo2',
      displayName: 'Baloo 2',
      Regular: {
        name: 'Baloo2-Regular',
        filename: 'Baloo2[wght].woff2',
        variable: true,
        variableWeight: 400
      },
      Bold: {
        name: 'Baloo2-Bold',
        filename: 'Baloo2[wght].woff2',
        variable: true,
        variableWeight: 700
      }
    },
    {
      fontFamily: 'BalooPaaji2',
      displayName: 'Baloo Paaji 2',
      Regular: {
        name: 'BalooPaaji2-Regular',
        filename: 'BalooPaaji2[wght].woff2',
        variable: true,
        variableWeight: 400
      },
      Bold: {
        name: 'BalooPaaji2-Bold',
        filename: 'BalooPaaji2[wght].woff2',
        variable: true,
        variableWeight: 700
      }
    },
    {
      fontFamily: 'Bangers',
      displayName: 'Bangers',
      Regular: {
        name: 'Bangers-Regular',
        filename: 'Bangers-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'Barlow',
      displayName: 'Barlow',
      Bold: {
        name: 'Barlow-Bold',
        filename: 'Barlow-Bold.woff2',
        variable: false
      },
      BoldItalic: {
        name: 'Barlow-BoldItalic',
        filename: 'Barlow-BoldItalic.woff2',
        variable: false
      },
      Italic: {
        name: 'Barlow-Italic',
        filename: 'Barlow-Italic.woff2',
        variable: false
      },
      Regular: {
        name: 'Barlow-Regular',
        filename: 'Barlow-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'BarlowCondensed',
      displayName: 'Barlow Condensed',
      Bold: {
        name: 'BarlowCondensed-Bold',
        filename: 'BarlowCondensed-Bold.woff2',
        variable: false
      },
      BoldItalic: {
        name: 'BarlowCondensed-BoldItalic',
        filename: 'BarlowCondensed-BoldItalic.woff2',
        variable: false
      },
      Italic: {
        name: 'BarlowCondensed-Italic',
        filename: 'BarlowCondensed-Italic.woff2',
        variable: false
      },
      Regular: {
        name: 'BarlowCondensed-Regular',
        filename: 'BarlowCondensed-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'Battambang',
      displayName: 'Battambang',
      Bold: {
        name: 'Battambang-Bold',
        filename: 'Battambang-Bold.woff2',
        variable: false
      },
      Regular: {
        name: 'Battambang-Regular',
        filename: 'Battambang-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'Bitter',
      displayName: 'Bitter',
      Italic: {
        name: 'Bitter-Italic',
        filename: 'Bitter-Italic[wght].woff2',
        variable: true,
        variableWeight: 400
      },
      BoldItalic: {
        name: 'Bitter-BoldItalic',
        filename: 'Bitter-Italic[wght].woff2',
        variable: true,
        variableWeight: 700
      },
      Regular: {
        name: 'Bitter-Regular',
        filename: 'Bitter[wght].woff2',
        variable: true,
        variableWeight: 400
      },
      Bold: {
        name: 'Bitter-Bold',
        filename: 'Bitter[wght].woff2',
        variable: true,
        variableWeight: 700
      }
    },
    {
      fontFamily: 'BlackHanSans',
      displayName: 'Black Han Sans',
      Regular: {
        name: 'BlackHanSans-Regular',
        filename: 'BlackHanSans-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'BlackOpsOne',
      displayName: 'Black Ops One',
      Regular: {
        name: 'BlackOpsOne-Regular',
        filename: 'BlackOpsOne-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'BreeSerif',
      displayName: 'Bree Serif',
      Regular: {
        name: 'BreeSerif-Regular',
        filename: 'BreeSerif-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'BrunoAceSC',
      displayName: 'Bruno Ace SC',
      Regular: {
        name: 'BrunoAceSC-Regular',
        filename: 'BrunoAceSC-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'Cairo',
      displayName: 'Cairo',
      Regular: {
        name: 'Cairo-Regular',
        filename: 'Cairo[wght].woff2',
        variable: true,
        variableWeight: 400
      },
      Bold: {
        name: 'Cairo-Bold',
        filename: 'Cairo[wght].woff2',
        variable: true,
        variableWeight: 700
      }
    },
    {
      fontFamily: 'Cardo',
      displayName: 'Cardo',
      Bold: {
        name: 'Cardo-Bold',
        filename: 'Cardo-Bold.woff2',
        variable: false
      },
      Italic: {
        name: 'Cardo-Italic',
        filename: 'Cardo-Italic.woff2',
        variable: false
      },
      Regular: {
        name: 'Cardo-Regular',
        filename: 'Cardo-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'Catamaran',
      displayName: 'Catamaran',
      Regular: {
        name: 'Catamaran-Regular',
        filename: 'Catamaran[wght].woff2',
        variable: true,
        variableWeight: 400
      },
      Bold: {
        name: 'Catamaran-Bold',
        filename: 'Catamaran[wght].woff2',
        variable: true,
        variableWeight: 700
      }
    },
    {
      fontFamily: 'Caveat',
      displayName: 'Caveat',
      Regular: {
        name: 'Caveat-Regular',
        filename: 'Caveat[wght].woff2',
        variable: true,
        variableWeight: 400
      },
      Bold: {
        name: 'Caveat-Bold',
        filename: 'Caveat[wght].woff2',
        variable: true,
        variableWeight: 700
      }
    },
    {
      fontFamily: 'ChelseaMarket',
      displayName: 'Chelsea Market',
      Regular: {
        name: 'ChelseaMarket-Regular',
        filename: 'ChelseaMarket-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'Cinzel',
      displayName: 'Cinzel',
      Regular: {
        name: 'Cinzel-Regular',
        filename: 'Cinzel[wght].woff2',
        variable: true,
        variableWeight: 400
      },
      Bold: {
        name: 'Cinzel-Bold',
        filename: 'Cinzel[wght].woff2',
        variable: true,
        variableWeight: 700
      }
    },
    {
      fontFamily: 'Comfortaa',
      displayName: 'Comfortaa',
      Regular: {
        name: 'Comfortaa-Regular',
        filename: 'Comfortaa-Regular.woff2',
        variable: false
      },
      Bold: {
        name: 'Comfortaa-Bold',
        filename: 'Comfortaa-Bold.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'Content',
      displayName: 'Content',
      skipBitmapGeneration: true,
      Bold: {
        name: 'Content-Bold',
        filename: 'Content-Bold.woff2',
        variable: false
      },
      Regular: {
        name: 'Content-Regular',
        filename: 'Content-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'Cookie',
      displayName: 'Cookie',
      Regular: {
        name: 'Cookie-Regular',
        filename: 'Cookie-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'Courgette',
      displayName: 'Courgette',
      Regular: {
        name: 'Courgette-Regular',
        filename: 'Courgette-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'DancingScript',
      displayName: 'Dancing Script',
      Regular: {
        name: 'DancingScript-Regular',
        filename: 'DancingScript[wght].woff2',
        variable: true,
        variableWeight: 400,
        pixelRange: 19
      },
      Bold: {
        name: 'DancingScript-Bold',
        filename: 'DancingScript[wght].woff2',
        variable: true,
        variableWeight: 700,
        pixelRange: 15
      }
    },
    {
      fontFamily: 'Dangrek',
      displayName: 'Dangrek',
      Regular: {
        name: 'Dangrek-Regular',
        filename: 'Dangrek-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'DavidLibre',
      displayName: 'David Libre',
      Bold: {
        name: 'DavidLibre-Bold',
        filename: 'DavidLibre-Bold.woff2',
        variable: false
      },
      Regular: {
        name: 'DavidLibre-Regular',
        filename: 'DavidLibre-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'Dosis',
      displayName: 'Dosis',
      Regular: {
        name: 'Dosis-Regular',
        filename: 'Dosis[wght].woff2',
        variable: true,
        variableWeight: 400
      },
      Bold: {
        name: 'Dosis-Bold',
        filename: 'Dosis[wght].woff2',
        variable: true,
        variableWeight: 700
      }
    },
    {
      fontFamily: 'Eater',
      displayName: 'Eater',
      Regular: {
        name: 'Eater-Regular',
        filename: 'Eater-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'Exo',
      displayName: 'Exo',
      Italic: {
        name: 'Exo-Italic',
        filename: 'Exo-Italic[wght].woff2',
        variable: true,
        variableWeight: 400
      },
      BoldItalic: {
        name: 'Exo-BoldItalic',
        filename: 'Exo-Italic[wght].woff2',
        variable: true,
        variableWeight: 700
      },
      Regular: {
        name: 'Exo-Regular',
        filename: 'Exo[wght].woff2',
        variable: true,
        variableWeight: 400
      },
      Bold: {
        name: 'Exo-Bold',
        filename: 'Exo[wght].woff2',
        variable: true,
        variableWeight: 700
      }
    },
    {
      fontFamily: 'Exo2',
      displayName: 'Exo 2',
      Italic: {
        name: 'Exo2-Italic',
        filename: 'Exo2-Italic[wght].woff2',
        variable: true,
        variableWeight: 400
      },
      BoldItalic: {
        name: 'Exo2-BoldItalic',
        filename: 'Exo2-Italic[wght].woff2',
        variable: true,
        variableWeight: 700
      },
      Regular: {
        name: 'Exo2-Regular',
        filename: 'Exo2[wght].woff2',
        variable: true,
        variableWeight: 400
      },
      Bold: {
        name: 'Exo2-Bold',
        filename: 'Exo2[wght].woff2',
        variable: true,
        variableWeight: 700
      }
    },
    {
      fontFamily: 'FiraSans',
      displayName: 'Fira Sans',
      Bold: {
        name: 'FiraSans-Bold',
        filename: 'FiraSans-Bold.woff2',
        variable: false
      },
      BoldItalic: {
        name: 'FiraSans-BoldItalic',
        filename: 'FiraSans-BoldItalic.woff2',
        variable: false
      },
      Italic: {
        name: 'FiraSans-Italic',
        filename: 'FiraSans-Italic.woff2',
        variable: false
      },
      Regular: {
        name: 'FiraSans-Regular',
        filename: 'FiraSans-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'FingerPaint',
      displayName: 'Finger Paint',
      skipBitmapGeneration: true,
      Regular: {
        name: 'FingerPaint-Regular',
        filename: 'FingerPaint-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'FjallaOne',
      displayName: 'Fjalla One',
      Regular: {
        name: 'FjallaOne-Regular',
        filename: 'FjallaOne-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'FredokaOne',
      displayName: 'Fredoka One',
      Regular: {
        name: 'FredokaOne-Regular',
        filename: 'FredokaOne-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'GloriaHallelujah',
      displayName: 'Gloria Hallelujah',
      skipBitmapGeneration: true,
      Regular: {
        name: 'GloriaHallelujah-Regular',
        filename: 'GloriaHallelujah.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'Galada',
      displayName: 'Galada',
      skipBitmapGeneration: true,
      Regular: {
        name: 'Galada-Regular',
        filename: 'Galada-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'GochiHand',
      displayName: 'Gochi Hand',
      Regular: {
        name: 'GochiHand-Regular',
        filename: 'GochiHand-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'GoogleSans',
      displayName: 'Google Sans',
      Regular: {
        name: 'GoogleSans-Regular',
        filename: 'GoogleSans-VariableFont_GRAD,opsz,wght.woff2',
        variable: true,
        variableWeight: 400
      },
      Bold: {
        name: 'GoogleSans-Bold',
        filename: 'GoogleSans-VariableFont_GRAD,opsz,wght.woff2',
        variable: true,
        variableWeight: 700
      },
      BoldItalic: {
        name: 'GoogleSans-BoldItalic',
        filename: 'GoogleSans-Italic-VariableFont_GRAD,opsz,wght.woff2',
        variable: true,
        variableWeight: 700
      },
      Italic: {
        name: 'GoogleSans-Italic',
        filename: 'GoogleSans-Italic-VariableFont_GRAD,opsz,wght.woff2',
        variable: true,
        variableWeight: 400
      }
    },
    {
      fontFamily: 'GreatVibes',
      displayName: 'Great Vibes',
      Regular: {
        name: 'GreatVibes-Regular',
        filename: 'GreatVibes-Regular.woff2',
        variable: false,
        pixelRange: 18
      }
    },
    {
      fontFamily: 'Handlee',
      displayName: 'Handlee',
      Regular: {
        name: 'Handlee-Regular',
        filename: 'Handlee-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'Hanuman',
      displayName: 'Hanuman',
      Bold: {
        name: 'Hanuman-Bold',
        filename: 'Hanuman-Bold.woff2',
        variable: false
      },
      Regular: {
        name: 'Hanuman-Regular',
        filename: 'Hanuman-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'Heebo',
      displayName: 'Heebo',
      Regular: {
        name: 'Heebo-Regular',
        filename: 'Heebo[wght].woff2',
        variable: true,
        variableWeight: 400
      },
      Bold: {
        name: 'Heebo-Bold',
        filename: 'Heebo[wght].woff2',
        variable: true,
        variableWeight: 700
      }
    },
    {
      fontFamily: 'Hind',
      displayName: 'Hind',
      Bold: {
        name: 'Hind-Bold',
        filename: 'Hind-Bold.woff2',
        variable: false
      },
      Regular: {
        name: 'Hind-Regular',
        filename: 'Hind-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'HindGuntur',
      displayName: 'Hind Guntur',
      Bold: {
        name: 'HindGuntur-Bold',
        filename: 'HindGuntur-Bold.woff2',
        variable: false
      },
      Regular: {
        name: 'HindGuntur-Regular',
        filename: 'HindGuntur-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'HindMadurai',
      displayName: 'Hind Madurai',
      Bold: {
        name: 'HindMadurai-Bold',
        filename: 'HindMadurai-Bold.woff2',
        variable: false
      },
      Regular: {
        name: 'HindMadurai-Regular',
        filename: 'HindMadurai-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'HindSiliguri',
      displayName: 'Hind Siliguri',
      Bold: {
        name: 'HindSiliguri-Bold',
        filename: 'HindSiliguri-Bold.woff2',
        variable: false
      },
      Regular: {
        name: 'HindSiliguri-Regular',
        filename: 'HindSiliguri-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'HindVadodara',
      displayName: 'Hind Vadodara',
      Bold: {
        name: 'HindVadodara-Bold',
        filename: 'HindVadodara-Bold.woff2',
        variable: false
      },
      Regular: {
        name: 'HindVadodara-Regular',
        filename: 'HindVadodara-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'Inconsolata',
      displayName: 'Inconsolata',
      Regular: {
        name: 'Inconsolata-Regular',
        filename: 'Inconsolata[wdth,wght].woff2',
        variable: true,
        variableWeight: 400
      },
      Bold: {
        name: 'Inconsolata-Bold',
        filename: 'Inconsolata[wdth,wght].woff2',
        variable: true,
        variableWeight: 700
      }
    },
    {
      fontFamily: 'IndieFlower',
      displayName: 'Indie Flower',
      Regular: {
        name: 'IndieFlower-Regular',
        filename: 'IndieFlower-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'JosefinSans',
      displayName: 'Josefin Sans',
      Italic: {
        name: 'JosefinSans-Italic',
        filename: 'JosefinSans-Italic[wght].woff2',
        variable: true,
        variableWeight: 400
      },
      BoldItalic: {
        name: 'JosefinSans-BoldItalic',
        filename: 'JosefinSans-Italic[wght].woff2',
        variable: true,
        variableWeight: 700
      },
      Regular: {
        name: 'JosefinSans-Regular',
        filename: 'JosefinSans[wght].woff2',
        variable: true,
        variableWeight: 400
      },
      Bold: {
        name: 'JosefinSans-Bold',
        filename: 'JosefinSans[wght].woff2',
        variable: true,
        variableWeight: 700
      }
    },
    {
      fontFamily: 'Kablammo',
      displayName: 'Kablammo',
      skipBitmapGeneration: true,
      Regular: {
        name: 'Kablammo-Regular',
        filename: 'Kablammo-Regular-VariableFont_MORF.woff2',
        variable: false // This is a variable font but has no weight axis
      }
    },
    {
      fontFamily: 'Kalam',
      displayName: 'Kalam',
      Bold: {
        name: 'Kalam-Bold',
        filename: 'Kalam-Bold.woff2',
        variable: false
      },
      Light: {
        name: 'Kalam-Light',
        filename: 'Kalam-Light.woff2',
        variable: false
      },
      Regular: {
        name: 'Kalam-Regular',
        filename: 'Kalam-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'Kanit',
      displayName: 'Kanit',
      Bold: {
        name: 'Kanit-Bold',
        filename: 'Kanit-Bold.woff2',
        variable: false
      },
      BoldItalic: {
        name: 'Kanit-BoldItalic',
        filename: 'Kanit-BoldItalic.woff2',
        variable: false
      },
      Italic: {
        name: 'Kanit-Italic',
        filename: 'Kanit-Italic.woff2',
        variable: false
      },
      Regular: {
        name: 'Kanit-Regular',
        filename: 'Kanit-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'KaushanScript',
      displayName: 'Kaushan Script',
      Regular: {
        name: 'KaushanScript-Regular',
        filename: 'KaushanScript-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'Kavivanar',
      displayName: 'Kavivanar',
      Regular: {
        name: 'Kavivanar-Regular',
        filename: 'Kavivanar-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'KosugiMaru',
      displayName: 'Kosugi Maru',
      Regular: {
        name: 'KosugiMaru-Regular',
        filename: 'KosugiMaru-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'Laila',
      displayName: 'Laila',
      Bold: {
        name: 'Laila-Bold',
        filename: 'Laila-Bold.woff2',
        variable: false
      },
      Regular: {
        name: 'Laila-Regular',
        filename: 'Laila-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'Lateef',
      displayName: 'Lateef',
      skipBitmapGeneration: true,
      Regular: {
        name: 'Lateef-Regular',
        filename: 'LateefRegOT.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'Lalezar',
      displayName: 'Lalezar',
      Regular: {
        name: 'Lalezar-Regular',
        filename: 'Lalezar-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'Lato',
      displayName: 'Lato',
      Bold: {
        name: 'Lato-Bold',
        filename: 'Lato-Bold.woff2',
        variable: false
      },
      BoldItalic: {
        name: 'Lato-BoldItalic',
        filename: 'Lato-BoldItalic.woff2',
        variable: false
      },
      Italic: {
        name: 'Lato-Italic',
        filename: 'Lato-Italic.woff2',
        variable: false
      },
      Regular: {
        name: 'Lato-Regular',
        filename: 'Lato-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'LavishlyYours',
      displayName: 'Lavishly Yours',
      skipBitmapGeneration: true,
      Regular: {
        name: 'LavishlyYours-Regular',
        filename: 'LavishlyYours-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'LibreBaskerville',
      displayName: 'Libre Baskerville',
      Bold: {
        name: 'LibreBaskerville-Bold',
        filename: 'LibreBaskerville-Bold.woff2',
        variable: false
      },
      Italic: {
        name: 'LibreBaskerville-Italic',
        filename: 'LibreBaskerville-Italic.woff2',
        variable: false
      },
      Regular: {
        name: 'LibreBaskerville-Regular',
        filename: 'LibreBaskerville-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'Lobster',
      displayName: 'Lobster',
      Regular: {
        name: 'Lobster-Regular',
        filename: 'Lobster-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'Lora',
      displayName: 'Lora',
      Italic: {
        name: 'Lora-Italic',
        filename: 'Lora-Italic[wght].woff2',
        variable: true,
        variableWeight: 400
      },
      BoldItalic: {
        name: 'Lora-BoldItalic',
        filename: 'Lora-Italic[wght].woff2',
        variable: true,
        variableWeight: 700
      },
      Regular: {
        name: 'Lora-Regular',
        filename: 'Lora[wght].woff2',
        variable: true,
        variableWeight: 400
      },
      Bold: {
        name: 'Lora-Bold',
        filename: 'Lora[wght].woff2',
        variable: true,
        variableWeight: 700
      }
    },
    {
      fontFamily: 'LuckiestGuy',
      displayName: 'Luckiest Guy',
      Regular: {
        name: 'LuckiestGuy-Regular',
        filename: 'LuckiestGuy-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'MPLUSRounded1c',
      displayName: 'M PLUS Rounded 1c',
      Bold: {
        name: 'MPLUSRounded1c-Bold',
        filename: 'MPLUSRounded1c-Bold.woff2',
        variable: false
      },
      Regular: {
        name: 'MPLUSRounded1c-Regular',
        filename: 'MPLUSRounded1c-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'Maitree',
      displayName: 'Maitree',
      Bold: {
        name: 'Maitree-Bold',
        filename: 'Maitree-Bold.woff2',
        variable: false
      },
      Regular: {
        name: 'Maitree-Regular',
        filename: 'Maitree-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'MaShanZheng',
      displayName: 'Ma Shan Zheng',
      Regular: {
        name: 'MaShanZheng-Regular',
        filename: 'MaShanZheng-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'MarckScript',
      displayName: 'Marck Script',
      Regular: {
        name: 'MarckScript-Regular',
        filename: 'MarckScript-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'Martel',
      displayName: 'Martel',
      Bold: {
        name: 'Martel-Bold',
        filename: 'Martel-Bold.woff2',
        variable: false
      },
      Regular: {
        name: 'Martel-Regular',
        filename: 'Martel-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'Merienda',
      displayName: 'Merienda',
      Bold: {
        name: 'Merienda-Bold',
        filename: 'Merienda-Bold.woff2',
        variable: false
      },
      Regular: {
        name: 'Merienda-Regular',
        filename: 'Merienda-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'Merriweather',
      displayName: 'Merriweather',
      Bold: {
        name: 'Merriweather-Bold',
        filename: 'Merriweather-Bold.woff2',
        variable: false
      },
      BoldItalic: {
        name: 'Merriweather-BoldItalic',
        filename: 'Merriweather-BoldItalic.woff2',
        variable: false
      },
      Italic: {
        name: 'Merriweather-Italic',
        filename: 'Merriweather-Italic.woff2',
        variable: false
      },
      Regular: {
        name: 'Merriweather-Regular',
        filename: 'Merriweather-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'Mina',
      displayName: 'Mina',
      Bold: {
        name: 'Mina-Bold',
        filename: 'Mina-Bold.woff2',
        variable: false
      },
      Regular: {
        name: 'Mina-Regular',
        filename: 'Mina-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'Mogra',
      displayName: 'Mogra',
      Regular: {
        name: 'Mogra-Regular',
        filename: 'Mogra-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'Monoton',
      displayName: 'Monoton',
      skipBitmapGeneration: true,
      Regular: {
        name: 'Monoton-Regular',
        filename: 'Monoton-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'MonsieurLaDoulaise',
      displayName: 'Monsieur La Doulaise',
      skipBitmapGeneration: true,
      Regular: {
        name: 'MonsieurLaDoulaise-Regular',
        filename: 'MonsieurLaDoulaise-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'Montserrat',
      displayName: 'Montserrat',
      Italic: {
        name: 'Montserrat-Italic',
        filename: 'Montserrat-Italic[wght].woff2',
        variable: true,
        variableWeight: 400
      },
      BoldItalic: {
        name: 'Montserrat-BoldItalic',
        filename: 'Montserrat-Italic[wght].woff2',
        variable: true,
        variableWeight: 700
      },
      Regular: {
        name: 'Montserrat-Regular',
        filename: 'Montserrat[wght].woff2',
        variable: true,
        variableWeight: 400
      },
      Bold: {
        name: 'Montserrat-Bold',
        filename: 'Montserrat[wght].woff2',
        variable: true,
        variableWeight: 700
      }
    },
    {
      fontFamily: 'Mukta',
      displayName: 'Mukta',
      Bold: {
        name: 'Mukta-Bold',
        filename: 'Mukta-Bold.woff2',
        variable: false
      },
      Regular: {
        name: 'Mukta-Regular',
        filename: 'Mukta-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'MuktaMahee',
      displayName: 'Mukta Mahee',
      Bold: {
        name: 'MuktaMahee-Bold',
        filename: 'MuktaMahee-Bold.woff2',
        variable: false
      },
      Regular: {
        name: 'MuktaMahee-Regular',
        filename: 'MuktaMahee-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'MuktaVaani',
      displayName: 'Mukta Vaani',
      Bold: {
        name: 'MuktaVaani-Bold',
        filename: 'MuktaVaani-Bold.woff2',
        variable: false
      },
      Regular: {
        name: 'MuktaVaani-Regular',
        filename: 'MuktaVaani-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'Muli',
      displayName: 'Muli',
      skipBitmapGeneration: false,
      Regular: {
        name: 'Muli-Regular',
        filename: 'Mulish-VariableFont_wght.woff2',
        variable: true,
        variableWeight: 400
      },
      Bold: {
        name: 'Muli-Bold',
        filename: 'Mulish-VariableFont_wght.woff2',
        variable: true,
        variableWeight: 700
      }
    },
    {
      fontFamily: 'MysteryQuest',
      displayName: 'Mystery Quest',
      Regular: {
        name: 'MysteryQuest-Regular',
        filename: 'MysteryQuest-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'NanumGothic',
      displayName: 'Nanum Gothic',
      Bold: {
        name: 'NanumGothic-Bold',
        filename: 'NanumGothic-Bold.woff2',
        variable: false
      },
      Regular: {
        name: 'NanumGothic-Regular',
        filename: 'NanumGothic-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'NanumMyeongjo',
      displayName: 'Nanum Myeongjo',
      Bold: {
        name: 'NanumMyeongjo-Bold',
        filename: 'NanumMyeongjo-Bold.woff2',
        variable: false
      },
      Regular: {
        name: 'NanumMyeongjo-Regular',
        filename: 'NanumMyeongjo-Regular.woff2',
        variable: false,
        pixelRange: 18
      }
    },
    {
      fontFamily: 'NanumPenScript',
      displayName: 'Nanum Pen Script',
      Regular: {
        name: 'NanumPenScript-Regular',
        filename: 'NanumPenScript-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'NotoKufiArabic',
      displayName: 'Noto Kufi Arabic',
      Regular: {
        name: 'NotoKufiArabic-Regular',
        filename: 'NotoKufiArabic[wght].woff2',
        variable: true,
        variableWeight: 400
      },
      Bold: {
        name: 'NotoKufiArabic-Bold',
        filename: 'NotoKufiArabic[wght].woff2',
        variable: true,
        variableWeight: 700
      }
    },
    {
      fontFamily: 'NotoSans',
      displayName: 'Noto Sans',
      Bold: {
        name: 'NotoSans-Bold',
        filename: 'NotoSans-Bold.woff2',
        variable: false
      },
      BoldItalic: {
        name: 'NotoSans-BoldItalic',
        filename: 'NotoSans-BoldItalic.woff2',
        variable: false
      },
      Italic: {
        name: 'NotoSans-Italic',
        filename: 'NotoSans-Italic.woff2',
        variable: false
      },
      Regular: {
        name: 'NotoSans-Regular',
        filename: 'NotoSans-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'NotoSansArabic',
      displayName: 'Noto Sans Arabic',
      skipBitmapGeneration: true,
      Regular: {
        name: 'NotoSansArabic-Regular',
        filename: 'NotoSansArabic[wdth,wght].woff2',
        variable: true,
        variableWeight: 400
      },
      Bold: {
        name: 'NotoSansArabic-Bold',
        filename: 'NotoSansArabic[wdth,wght].woff2',
        variable: true,
        variableWeight: 700
      }
    },
    {
      fontFamily: 'NotoSansDevanagari',
      displayName: 'Noto Sans Devanagari',
      Regular: {
        name: 'NotoSansDevanagari-Regular',
        filename: 'NotoSansDevanagari-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'NotoSansKR',
      displayName: 'Noto Sans KR',
      skipBitmapGeneration: false,
      Regular: {
        name: 'NotoSansKR-Regular',
        filename: 'NotoSansKR-VariableFont_wght.woff2',
        variable: true,
        variableWeight: 400
      },
      Bold: {
        name: 'NotoSansKR-Bold',
        filename: 'NotoSansKR-VariableFont_wght.woff2',
        variable: true,
        variableWeight: 700
      }
    },
    {
      fontFamily: 'NotoSansSC',
      displayName: 'Noto Sans SC',
      skipBitmapGeneration: true,
      Regular: {
        name: 'NotoSansSC-Regular',
        filename: 'NotoSansSC-VariableFont_wght.woff2',
        variable: true,
        variableWeight: 400
      },
      Bold: {
        name: 'NotoSansSC-Bold',
        filename: 'NotoSansSC-VariableFont_wght.woff2',
        variable: true,
        variableWeight: 700
      }
    },
    {
      fontFamily: 'NotoSansTagalog',
      displayName: 'Noto Sans Tagalog',
      skipBitmapGeneration: true,
      Regular: {
        name: 'NotoSansTagalog-Regular',
        filename: 'NotoSansTagalog-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'NotoSerif',
      displayName: 'Noto Serif',
      Bold: {
        name: 'NotoSerif-Bold',
        filename: 'NotoSerif-Bold.woff2',
        variable: false
      },
      Regular: {
        name: 'NotoSerif-Regular',
        filename: 'NotoSerif-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'NotoSerifJP',
      displayName: 'Noto Serif JP',
      skipBitmapGeneration: true,
      Regular: {
        name: 'NotoSerifJP-Regular',
        filename: 'NotoSerifJP-VariableFont_wght.woff2',
        variable: true,
        variableWeight: 400
      },
      Bold: {
        name: 'NotoSerifJP-Bold',
        filename: 'NotoSerifJP-VariableFont_wght.woff2',
        variable: true,
        variableWeight: 700
      }
    },
    {
      fontFamily: 'NotoSerifSC',
      displayName: 'Noto Serif SC',
      skipBitmapGeneration: true,
      Regular: {
        name: 'NotoSerifSC-Regular',
        filename: 'NotoSerifSC-VariableFont_wght.woff2',
        variable: true,
        variableWeight: 400
      },
      Bold: {
        name: 'NotoSerifSC-Bold',
        filename: 'NotoSerifSC-VariableFont_wght.woff2',
        variable: true,
        variableWeight: 700
      }
    },
    {
      fontFamily: 'Nunito',
      displayName: 'Nunito',
      Italic: {
        name: 'Nunito-Italic',
        filename: 'Nunito-Italic[wght].woff2',
        variable: true,
        variableWeight: 400
      },
      BoldItalic: {
        name: 'Nunito-BoldItalic',
        filename: 'Nunito-Italic[wght].woff2',
        variable: true,
        variableWeight: 700
      },
      Regular: {
        name: 'Nunito-Regular',
        filename: 'Nunito[wght].woff2',
        variable: true,
        variableWeight: 400
      },
      Bold: {
        name: 'Nunito-Bold',
        filename: 'Nunito[wght].woff2',
        variable: true,
        variableWeight: 700
      }
    },
    {
      fontFamily: 'OpenSans',
      displayName: 'Open Sans',
      Italic: {
        name: 'OpenSans-Italic',
        filename: 'OpenSans-Italic[wdth,wght].woff2',
        variable: true,
        variableWeight: 400
      },
      BoldItalic: {
        name: 'OpenSans-BoldItalic',
        filename: 'OpenSans-Italic[wdth,wght].woff2',
        variable: true,
        variableWeight: 700
      },
      Regular: {
        name: 'OpenSans-Regular',
        filename: 'OpenSans[wdth,wght].woff2',
        variable: true,
        variableWeight: 400
      },
      Bold: {
        name: 'OpenSans-Bold',
        filename: 'OpenSans[wdth,wght].woff2',
        variable: true,
        variableWeight: 700
      }
    },
    {
      fontFamily: 'Oswald',
      displayName: 'Oswald',
      Regular: {
        name: 'Oswald-Regular',
        filename: 'Oswald[wght].woff2',
        variable: true,
        variableWeight: 400
      },
      Bold: {
        name: 'Oswald-Bold',
        filename: 'Oswald[wght].woff2',
        variable: true,
        variableWeight: 700
      }
    },
    {
      fontFamily: 'Overpass',
      displayName: 'Overpass',
      Italic: {
        name: 'Overpass-Italic',
        filename: 'Overpass-Italic[wght].woff2',
        variable: true,
        variableWeight: 400
      },
      BoldItalic: {
        name: 'Overpass-BoldItalic',
        filename: 'Overpass-Italic[wght].woff2',
        variable: true,
        variableWeight: 700
      },
      Regular: {
        name: 'Overpass-Regular',
        filename: 'Overpass[wght].woff2',
        variable: true,
        variableWeight: 400
      },
      Bold: {
        name: 'Overpass-Bold',
        filename: 'Overpass[wght].woff2',
        variable: true,
        variableWeight: 700
      }
    },
    {
      fontFamily: 'Oxygen',
      displayName: 'Oxygen',
      Bold: {
        name: 'Oxygen-Bold',
        filename: 'Oxygen-Bold.woff2',
        variable: false
      },
      Regular: {
        name: 'Oxygen-Regular',
        filename: 'Oxygen-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'PT_Sans',
      displayName: 'PT Sans',
      Web: {
        name: 'PT_Sans-Web',
        filename: 'PT_Sans-Web-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'PT_Serif',
      displayName: 'PT Serif',
      Web: {
        name: 'PT_Serif-Web',
        filename: 'PT_Serif-Web-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'Pacifico',
      displayName: 'Pacifico',
      Regular: {
        name: 'Pacifico-Regular',
        filename: 'Pacifico-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'Padauk',
      displayName: 'Padauk',
      Bold: {
        name: 'Padauk-Bold',
        filename: 'Padauk-Bold.woff2',
        variable: false
      },
      Regular: {
        name: 'Padauk-Regular',
        filename: 'Padauk-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'PatrickHand',
      displayName: 'Patrick Hand',
      Regular: {
        name: 'PatrickHand-Regular',
        filename: 'PatrickHand-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'PatuaOne',
      displayName: 'Patua One',
      Regular: {
        name: 'PatuaOne-Regular',
        filename: 'PatuaOne-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'Pavanam',
      displayName: 'Pavanam',
      Regular: {
        name: 'Pavanam-Regular',
        filename: 'Pavanam-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'Peddana',
      displayName: 'Peddana',
      Regular: {
        name: 'Peddana-Regular',
        filename: 'Peddana-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'PermanentMarker',
      displayName: 'Permanent Marker',
      Regular: {
        name: 'PermanentMarker-Regular',
        filename: 'PermanentMarker-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'PlayfairDisplay',
      displayName: 'Playfair Display',
      Italic: {
        name: 'PlayfairDisplay-Italic',
        filename: 'PlayfairDisplay-Italic[wght].woff2',
        variable: true,
        variableWeight: 400,
        pixelRange: 20
      },
      BoldItalic: {
        name: 'PlayfairDisplay-BoldItalic',
        filename: 'PlayfairDisplay-Italic[wght].woff2',
        variable: true,
        variableWeight: 700,
        pixelRange: 20
      },
      Regular: {
        name: 'PlayfairDisplay-Regular',
        filename: 'PlayfairDisplay[wght].woff2',
        variable: true,
        variableWeight: 400,
        pixelRange: 20
      },
      Bold: {
        name: 'PlayfairDisplay-Bold',
        filename: 'PlayfairDisplay[wght].woff2',
        variable: true,
        variableWeight: 700,
        pixelRange: 20
      }
    },
    {
      fontFamily: 'PoiretOne',
      displayName: 'Poiret One',
      Regular: {
        name: 'PoiretOne-Regular',
        filename: 'PoiretOne-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'Poppins',
      displayName: 'Poppins',
      Bold: {
        name: 'Poppins-Bold',
        filename: 'Poppins-Bold.woff2',
        variable: false
      },
      BoldItalic: {
        name: 'Poppins-BoldItalic',
        filename: 'Poppins-BoldItalic.woff2',
        variable: false
      },
      Italic: {
        name: 'Poppins-Italic',
        filename: 'Poppins-Italic.woff2',
        variable: false
      },
      Regular: {
        name: 'Poppins-Regular',
        filename: 'Poppins-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'Pridi',
      displayName: 'Pridi',
      Bold: {
        name: 'Pridi-Bold',
        filename: 'Pridi-Bold.woff2',
        variable: false
      },
      Regular: {
        name: 'Pridi-Regular',
        filename: 'Pridi-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'Prompt',
      displayName: 'Prompt',
      Bold: {
        name: 'Prompt-Bold',
        filename: 'Prompt-Bold.woff2',
        variable: false
      },
      BoldItalic: {
        name: 'Prompt-BoldItalic',
        filename: 'Prompt-BoldItalic.woff2',
        variable: false
      },
      Italic: {
        name: 'Prompt-Italic',
        filename: 'Prompt-Italic.woff2',
        variable: false
      },
      Regular: {
        name: 'Prompt-Regular',
        filename: 'Prompt-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'Questrial',
      displayName: 'Questrial',
      Regular: {
        name: 'Questrial-Regular',
        filename: 'Questrial-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'Quicksand',
      displayName: 'Quicksand',
      Regular: {
        name: 'Quicksand-Regular',
        filename: 'Quicksand[wght].woff2',
        variable: true,
        variableWeight: 400
      },
      Bold: {
        name: 'Quicksand-Bold',
        filename: 'Quicksand[wght].woff2',
        variable: true,
        variableWeight: 700
      }
    },
    {
      fontFamily: 'Rajdhani',
      displayName: 'Rajdhani',
      Bold: {
        name: 'Rajdhani-Bold',
        filename: 'Rajdhani-Bold.woff2',
        variable: false
      },
      Regular: {
        name: 'Rajdhani-Regular',
        filename: 'Rajdhani-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'Raleway',
      displayName: 'Raleway',
      Italic: {
        name: 'Raleway-Italic',
        filename: 'Raleway-Italic[wght].woff2',
        variable: true,
        variableWeight: 400
      },
      BoldItalic: {
        name: 'Raleway-BoldItalic',
        filename: 'Raleway-Italic[wght].woff2',
        variable: true,
        variableWeight: 700
      },
      Regular: {
        name: 'Raleway-Regular',
        filename: 'Raleway[wght].woff2',
        variable: true,
        variableWeight: 400
      },
      Bold: {
        name: 'Raleway-Bold',
        filename: 'Raleway[wght].woff2',
        variable: true,
        variableWeight: 700
      }
    },
    {
      fontFamily: 'Rasa',
      displayName: 'Rasa',
      Italic: {
        name: 'Rasa-Italic',
        filename: 'Rasa-Italic[wght].woff2',
        variable: true,
        variableWeight: 400
      },
      BoldItalic: {
        name: 'Rasa-BoldItalic',
        filename: 'Rasa-Italic[wght].woff2',
        variable: true,
        variableWeight: 700
      },
      Regular: {
        name: 'Rasa-Regular',
        filename: 'Rasa[wght].woff2',
        variable: true,
        variableWeight: 400
      },
      Bold: {
        name: 'Rasa-Bold',
        filename: 'Rasa[wght].woff2',
        variable: true,
        variableWeight: 700
      }
    },
    {
      fontFamily: 'Righteous',
      displayName: 'Righteous',
      Regular: {
        name: 'Righteous-Regular',
        filename: 'Righteous-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'Roboto',
      displayName: 'Roboto',
      Bold: {
        name: 'Roboto-Bold',
        filename: 'Roboto-Bold.woff2',
        variable: false
      },
      BoldItalic: {
        name: 'Roboto-BoldItalic',
        filename: 'Roboto-BoldItalic.woff2',
        variable: false
      },
      Italic: {
        name: 'Roboto-Italic',
        filename: 'Roboto-Italic.woff2',
        variable: false
      },
      Regular: {
        name: 'Roboto-Regular',
        filename: 'Roboto-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'RobotoCondensed',
      displayName: 'Roboto Condensed',
      Bold: {
        name: 'RobotoCondensed-Bold',
        filename: 'RobotoCondensed-Bold.woff2',
        variable: false
      },
      BoldItalic: {
        name: 'RobotoCondensed-BoldItalic',
        filename: 'RobotoCondensed-BoldItalic.woff2',
        variable: false
      },
      Italic: {
        name: 'RobotoCondensed-Italic',
        filename: 'RobotoCondensed-Italic.woff2',
        variable: false
      },
      Regular: {
        name: 'RobotoCondensed-Regular',
        filename: 'RobotoCondensed-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'RockSalt',
      displayName: 'Rock Salt',
      Regular: {
        name: 'RockSalt-Regular',
        filename: 'RockSalt-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'Rubik',
      displayName: 'Rubik',
      Italic: {
        name: 'Rubik-Italic',
        filename: 'Rubik-Italic[wght].woff2',
        variable: true,
        variableWeight: 400
      },
      BoldItalic: {
        name: 'Rubik-BoldItalic',
        filename: 'Rubik-Italic[wght].woff2',
        variable: true,
        variableWeight: 700
      },
      Regular: {
        name: 'Rubik-Regular',
        filename: 'Rubik[wght].woff2',
        variable: true,
        variableWeight: 400
      },
      Bold: {
        name: 'Rubik-Bold',
        filename: 'Rubik[wght].woff2',
        variable: true,
        variableWeight: 700
      }
    },
    {
      fontFamily: 'Sacramento',
      displayName: 'Sacramento',
      Regular: {
        name: 'Sacramento-Regular',
        filename: 'Sacramento-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'Satisfy',
      displayName: 'Satisfy',
      Regular: {
        name: 'Satisfy-Regular',
        filename: 'Satisfy-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'SawarabiGothic',
      displayName: 'Sawarabi Gothic',
      Regular: {
        name: 'SawarabiGothic-Regular',
        filename: 'SawarabiGothic-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'SawarabiMincho',
      displayName: 'Sawarabi Mincho',
      Regular: {
        name: 'SawarabiMincho-Regular',
        filename: 'SawarabiMincho-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'ShadowsIntoLight',
      displayName: 'Shadows Into Light',
      skipBitmapGeneration: true,
      Regular: {
        name: 'ShadowsIntoLight-Regular',
        filename: 'ShadowsIntoLight-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'Shrikhand',
      displayName: 'Shrikhand',
      Regular: {
        name: 'Shrikhand-Regular',
        filename: 'Shrikhand-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'Slackey',
      displayName: 'Slackey',
      Regular: {
        name: 'Slackey-Regular',
        filename: 'Slackey-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'Slabo27px',
      displayName: 'Slabo 27px',
      Regular: {
        name: 'Slabo27px-Regular',
        filename: 'Slabo27px-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'SongMyung',
      displayName: 'Song Myung',
      Regular: {
        name: 'SongMyung-Regular',
        filename: 'SongMyung-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'SourceCodePro',
      displayName: 'Source Code Pro',
      Italic: {
        name: 'SourceCodePro-Italic',
        filename: 'SourceCodePro-Italic[wght].woff2',
        variable: true,
        variableWeight: 400
      },
      BoldItalic: {
        name: 'SourceCodePro-BoldItalic',
        filename: 'SourceCodePro-Italic[wght].woff2',
        variable: true,
        variableWeight: 700
      },
      Regular: {
        name: 'SourceCodePro-Regular',
        filename: 'SourceCodePro[wght].woff2',
        variable: true,
        variableWeight: 400
      },
      Bold: {
        name: 'SourceCodePro-Bold',
        filename: 'SourceCodePro[wght].woff2',
        variable: true,
        variableWeight: 700
      }
    },
    {
      fontFamily: 'SourceSansPro',
      displayName: 'Source Sans Pro',
      Bold: {
        name: 'SourceSansPro-Bold',
        filename: 'SourceSansPro-Bold.woff2',
        variable: false
      },
      BoldItalic: {
        name: 'SourceSansPro-BoldItalic',
        filename: 'SourceSansPro-BoldItalic.woff2',
        variable: false
      },
      Italic: {
        name: 'SourceSansPro-Italic',
        filename: 'SourceSansPro-Italic.woff2',
        variable: false
      },
      Regular: {
        name: 'SourceSansPro-Regular',
        filename: 'SourceSansPro-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'SourceSerifPro',
      displayName: 'Source Serif Pro',
      Bold: {
        name: 'SourceSerifPro-Bold',
        filename: 'SourceSerifPro-Bold.woff2',
        variable: false
      },
      BoldItalic: {
        name: 'SourceSerifPro-BoldItalic',
        filename: 'SourceSerifPro-BoldItalic.woff2',
        variable: false
      },
      Italic: {
        name: 'SourceSerifPro-Italic',
        filename: 'SourceSerifPro-Italic.woff2',
        variable: false
      },
      Regular: {
        name: 'SourceSerifPro-Regular',
        filename: 'SourceSerifPro-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'SpecialElite',
      displayName: 'Special Elite',
      Regular: {
        name: 'SpecialElite-Regular',
        filename: 'SpecialElite-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'SreeKrushnadevaraya',
      displayName: 'Sree Krushnadevaraya',
      Regular: {
        name: 'SreeKrushnadevaraya-Regular',
        filename: 'SreeKrushnadevaraya-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'Sriracha',
      displayName: 'Sriracha',
      Regular: {
        name: 'Sriracha-Regular',
        filename: 'Sriracha-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'StoryScript',
      displayName: 'Story Script',
      Regular: {
        name: 'StoryScript-Regular',
        filename: 'StoryScript-Regular.woff2 ',
        variable: false
      }
    },
    {
      fontFamily: 'Suranna',
      displayName: 'Suranna',
      Regular: {
        name: 'Suranna-Regular',
        filename: 'Suranna-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'Tajawal',
      displayName: 'Tajawal',
      Bold: {
        name: 'Tajawal-Bold',
        filename: 'Tajawal-Bold.woff2',
        variable: false
      },
      Regular: {
        name: 'Tajawal-Regular',
        filename: 'Tajawal-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'Teko',
      displayName: 'Teko',
      Bold: {
        name: 'Teko-Bold',
        filename: 'Teko-Bold.woff2',
        variable: false
      },
      Regular: {
        name: 'Teko-Regular',
        filename: 'Teko-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'TenaliRamakrishna',
      displayName: 'Tenali Ramakrishna',
      Regular: {
        name: 'TenaliRamakrishna-Regular',
        filename: 'TenaliRamakrishna-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'TitilliumWeb',
      displayName: 'Titillium Web',
      Bold: {
        name: 'TitilliumWeb-Bold',
        filename: 'TitilliumWeb-Bold.woff2',
        variable: false
      },
      BoldItalic: {
        name: 'TitilliumWeb-BoldItalic',
        filename: 'TitilliumWeb-BoldItalic.woff2',
        variable: false
      },
      Italic: {
        name: 'TitilliumWeb-Italic',
        filename: 'TitilliumWeb-Italic.woff2',
        variable: false
      },
      Regular: {
        name: 'TitilliumWeb-Regular',
        filename: 'TitilliumWeb-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'Ubuntu',
      displayName: 'Ubuntu',
      Bold: {
        name: 'Ubuntu-Bold',
        filename: 'Ubuntu-Bold.woff2',
        variable: false
      },
      BoldItalic: {
        name: 'Ubuntu-BoldItalic',
        filename: 'Ubuntu-BoldItalic.woff2',
        variable: false
      },
      Italic: {
        name: 'Ubuntu-Italic',
        filename: 'Ubuntu-Italic.woff2',
        variable: false
      },
      Regular: {
        name: 'Ubuntu-Regular',
        filename: 'Ubuntu-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'VarelaRound',
      displayName: 'Varela Round',
      Regular: {
        name: 'VarelaRound-Regular',
        filename: 'VarelaRound-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'Viga',
      displayName: 'Viga',
      Regular: {
        name: 'Viga-Regular',
        filename: 'Viga-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'Vollkorn',
      displayName: 'Vollkorn',
      Italic: {
        name: 'Vollkorn-Italic',
        filename: 'Vollkorn-Italic[wght].woff2',
        variable: true,
        variableWeight: 400
      },
      BoldItalic: {
        name: 'Vollkorn-BoldItalic',
        filename: 'Vollkorn-Italic[wght].woff2',
        variable: true,
        variableWeight: 700
      },
      Regular: {
        name: 'Vollkorn-Regular',
        filename: 'Vollkorn[wght].woff2',
        variable: true,
        variableWeight: 400
      },
      Bold: {
        name: 'Vollkorn-Bold',
        filename: 'Vollkorn[wght].woff2',
        variable: true,
        variableWeight: 700
      }
    },
    {
      fontFamily: 'WorkSans',
      displayName: 'Work Sans',
      Italic: {
        name: 'WorkSans-Italic',
        filename: 'WorkSans-Italic[wght].woff2',
        variable: true,
        variableWeight: 400
      },
      BoldItalic: {
        name: 'WorkSans-BoldItalic',
        filename: 'WorkSans-Italic[wght].woff2',
        variable: true,
        variableWeight: 700
      },
      Regular: {
        name: 'WorkSans-Regular',
        filename: 'WorkSans[wght].woff2',
        variable: true,
        variableWeight: 400
      },
      Bold: {
        name: 'WorkSans-Bold',
        filename: 'WorkSans[wght].woff2',
        variable: true,
        variableWeight: 700
      }
    },
    {
      fontFamily: 'YanoneKaffeesatz',
      displayName: 'Yanone Kaffeesatz',
      Regular: {
        name: 'YanoneKaffeesatz-Regular',
        filename: 'YanoneKaffeesatz[wght].woff2',
        variable: true,
        variableWeight: 400
      },
      Bold: {
        name: 'YanoneKaffeesatz-Bold',
        filename: 'YanoneKaffeesatz[wght].woff2',
        variable: true,
        variableWeight: 700
      }
    },
    {
      fontFamily: 'Yellowtail',
      displayName: 'Yellowtail',
      Regular: {
        name: 'Yellowtail-Regular',
        filename: 'Yellowtail-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'ZhiMangXing',
      displayName: 'Zhi Mang Xing',
      Regular: {
        name: 'ZhiMangXing-Regular',
        filename: 'ZhiMangXing-Regular.woff2',
        variable: false
      }
    },
    {
      fontFamily: 'ZillaSlab',
      displayName: 'Zilla Slab',
      Bold: {
        name: 'ZillaSlab-Bold',
        filename: 'ZillaSlab-Bold.woff2',
        variable: false
      },
      BoldItalic: {
        name: 'ZillaSlab-BoldItalic',
        filename: 'ZillaSlab-BoldItalic.woff2',
        variable: false
      },
      Italic: {
        name: 'ZillaSlab-Italic',
        filename: 'ZillaSlab-Italic.woff2',
        variable: false
      },
      Regular: {
        name: 'ZillaSlab-Regular',
        filename: 'ZillaSlab-Regular.woff2',
        variable: false
      }
    }
  ]
};
